import React from 'react';
import TaxonomySelection from '../../helper/taxonomySelection';
import MetadataSelection from '../../helper/metadataSelection';
import Select from 'react-select';
import { findIndex } from 'underscore';
import clone from 'clone';
import BuildActions from '../../builder/action/builderActions';
import panelActions from '../action/panelActions';
import ReactToggle from 'react-toggle';
import { stringify } from '../../helper/helperFunction';

class TagPanel extends React.Component {
    constructor(props) {
      super(props);
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      this.handleTaxonomy = this.handleTaxonomy.bind(this);
      this.handleMetakey = this.handleMetakey.bind(this);
      this.handleChangeDataTypes = this.handleChangeDataTypes.bind(this);
      this.handleChangeSelectTypes = this.handleChangeSelectTypes.bind(this);
      this.handleChangeToogleViewTypes = this.handleChangeToogleViewTypes.bind(this);
      this.saveData = this.saveData.bind(this);
      this.state = {
        settings: {
          selectedType: {
            value: 'singleselect',
          },
        },
      };
      this.datatypes = [
        {
          'label': 'Taxonomy',
          'value': 'taxonomies',
        },
      ];
      this.selecttypes = [
        {
          'label': 'Multi-Select',
          'value': 'multiselect',
        },
        {
          'label': 'Single-Select',
          'value': 'singleselect',
        },
      ];
      this.toogleviewtype = [
        {
          'label': 'Toogle Show On',
          'value': 'true',
        },
        {
          'label': 'Toogle Show Off',
          'value': 'false',
        },
      ];
      this.settings = {};
    }
    componentWillMount() {
      this.settings = { ...this.props.settings };
      this.setState({
        'settings': { ...this.state.settings, ...this.props.settings },
      });
    }
    componentWillReceiveProps(nextProps) {
      if (nextProps.childUid !== this.props.childUid) {
        this.setState({
          'settings': { ...this.state.settings, ...nextProps.settings },
        });
        this.settings = { ...this.state.settings };
      }
    }
    handleTaxonomy(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedTaxonomy = value;
      this.setState({
        settings: { ...this.state.settings, ...this.settings },
      });
    }
    handleMetakey(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedMetakey = value;
      this.setState({
        settings: { ...this.state.settings, ...this.settings },
      });
    }
    handleChangeDataTypes(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedDataType = value;
      this.setState({
        settings: { ...this.state.settings, ...this.settings },
      });
    }
    handleChangeSelectTypes(val) {
      this.settings.selectedType = val;
      this.setState({
        settings: { ...this.state.settings, ...this.settings },
      });
    }
    handelTitle(e) {
      this.settings.title = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleChangeToogleViewTypes(val) {
      this.settings.selectedToogleViewType = val.target.checked;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelSubTitle(e) {
      this.settings.subtitle = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    saveData(e) {
      e.preventDefault();
      const allLayout = clone(this.props.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        const findSearchIndex = findIndex(allLayout[find].searchAttr, { uid: this.props.childUid });
        if (findSearchIndex !== -1) {
          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
        }
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);
    }
    render() {
      return (<div>
        <button className="layout-save-button" onClick={this.saveData}><i className="fa fa-floppy-o"></i><span>{API.LANG.SAVE}</span></button>
        <div className="reactive-tab-setting">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#appearance" aria-controls="general" role="tab" data-toggle="tab">{API.LANG.APPEARANCE}</a></li>
            <li role="presentation"><a href="#populate" aria-controls="populate" role="tab" data-toggle="tab">{API.LANG.DATA}</a></li>
          </ul>
          <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="appearance">
              <input type="text" className="reactive-input" value= {stringify(this.state.settings.title)} onChange= { this.handelTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_TITLE}/>
              <input type="text" className="reactive-input" value= {stringify(this.state.settings.subtitle)} onChange= { this.handelSubTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_SUBTITLE}/>
              <Select
                name="form-field-name"
                placeholder={API.LANG.PLEASE_CHOOSE_A_SELECT_TYPE}
                value={this.state.settings.selectedType !== undefined ? this.state.settings.selectedType.value : ''}
                options={this.selecttypes}
                onChange={this.handleChangeSelectTypes}
              />

              <div className="grid-choose-option">
                <div className="flex-row ">
                  <div className="flex-sm-3 flex-xs-12">
                    <span className="caption">{API.LANG.TOGGLE_OPTION}</span>
                  </div>
                  <div className="flex-sm-9 flex-xs-12">
                    <div className="choose-grid-button">
                      <ReactToggle
                        defaultChecked={this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true}
                        onChange={this.handleChangeToogleViewTypes.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div role="tabpanel" className="tab-pane" id="populate">
          { /**
            Please select data type
          */}
          <div className="flex-row">
          <div className="flex-sm-6 flex-md-6 flex-xs-12">
            <Select
              name="form-field-name"
              placeholder={API.LANG.PLEASE_ENTER_A_DATA_TYPE}
              value={this.state.settings.selectedDataType}
              options={this.datatypes}
              onChange={this.handleChangeDataTypes}
            />
          </div>
          </div>

            { this.state.settings.selectedDataType === 'taxonomies' ? <TaxonomySelection onTaxonomySelection={this.handleTaxonomy} value={this.state.settings.selectedTaxonomy} {...this.props} /> : null }
            { this.state.settings.selectedDataType === 'metakeys' ? <MetadataSelection onMetakeySelection={this.handleMetakey} value={this.state.settings.selectedMetakey} {...this.props} /> : null }


            </div>
          </div>
        </div>

      </div>);
    }
}


TagPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'childUid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'settings': React.PropTypes.object,
};

export default TagPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/search/tagPanel.js
 **/